import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function SelfImprovementIcon(props: IconProps) {
    return <Icon {...props} iconKey={"self_improvement"}/>
}
